<template>
  <transition name="msgbox-fade">
    <div
      class="el-message-box__wrapper popup draggable-popup"
      tabindex="-1"
      v-show="visible"
      @click.self="handleWrapperClick"
      role="dialog"
      aria-modal="true"
      :aria-label="title || 'dialog'">
      <div ref="elMessageBoxContainer" class="el-message-box calc-message-box" :class="[center && 'el-message-box--center']" :style="{width: width}">
        <div ref="elMessageHeader" class="el-message-box__header" v-if="title !== null" :style="{background: background}">
          <div class="el-message-box__title">
            <div
              :class="['el-message-box__status', icon]"
              v-if="icon && center">
            </div>
            <span>{{ title }}</span>
          </div>
          <button
            type="button"
            class="el-message-box__headerbtn"
            aria-label="Close"
            v-if="showClose"
            @click="closeMessageBox"
            @keydown.enter="closeMessageBox">
            <i class="el-message-box__close el-icon-close"></i>
          </button>
        </div>
        <div class="el-message-box__content">
          <component ref="component" :is="component" :parameter="parameter" @closeFourmal="closeFourmal"></component>
        </div>
        <div class="el-message-box__btns" style="text-align: center">
          <el-button
            class="el-button--primary"
            :loading="confirmButtonLoading"
            ref="confirm"
            :round="roundButton"
            size="small"
            @click.native="handleAction('confirm')"
            @keydown.enter="handleAction('confirm')">
           保存
          </el-button>
          <el-button
            :loading="cancelButtonLoading"
            :round="roundButton"
            size="small"
            @click.native="handleAction('cancel')"
            @keydown.enter="handleAction('cancel')">
            {{ cancelButtonText || t('el.messagebox.cancel') }}
          </el-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script type="text/babel">
import Popup from 'element-ui/lib/utils/popup'
import Locale from 'element-ui/lib/mixins/locale'
import ElButton from 'element-ui/packages/button'
import Dialog from 'element-ui/lib/utils/aria-dialog'
import Calculation from '../calculation/calculation'
import move from '../../plugins/move'

let popup

export default {
  mixins: [Popup, Locale],
  props: {
    modal: {
      default: false
    },
    lockScroll: {
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    closeOnClickModal: {
      default: false
    },
    closeOnPressEscape: {
      default: true
    },
    closeOnHashChange: {
      default: true
    },
    center: {
      default: false,
      type: Boolean
    },
    roundButton: {
      default: false,
      type: Boolean
    }
  },
  components: {
    Calculation,
    ElButton
  },

  computed: {
    icon () {
      const iconClass = this
      return iconClass
    }
  },
  methods: {
    getSafeClose () {
      const currentId = this.uid
      return () => {
        this.$nextTick(() => {
          if (currentId === this.uid) this.doClose()
        })
      }
    },
    doClose () {
      let _this = this
      if (this.action === 'confirm') {
        this.$refs.component.validate().then(() => {
          _this.value = _this.$refs.component === undefined ? _this.value : _this.$refs.component.getValue()
          _this.closePanel()
        }).catch(error => {
          this.$message.error(error.message)
        })
      } else {
        this.closePanel()
      }
    },
    closePanel () {
      if (!this.visible) return
      this.visible = false

      this.onClose && this.onClose()
      popup.closeDialog() // 解绑
      if (this.lockScroll) {
        setTimeout(this.restoreBodyStyle, 200)
      }
      this.opened = false
      this.doAfterClose()
      let _this = this
      setTimeout(() => {
        if (_this.action) _this.callback(_this.action, _this.value)
        _this.component = ''
      })
    },
    handleWrapperClick () {
      if (this.closeOnClickModal) {
        this.handleAction(this.distinguishCancelAndClose ? 'close' : 'cancel')
      }
    },
    handleAction (action) {
      this.action = action
      if (action === 'confirm') {
        if (this.$refs.component.calculationType.toLocaleLowerCase() === 'java' && this.$refs.component.currentColumnId && this.$refs.component.getValue().includes(this.$refs.component.currentColumnId)) {
          this.$confirm('', '表达式中包含变量自身，可能会导致计算无限循环执行，确认保存?', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            customClass: 'publishMessageBox',
            center: true
          }).then(() => {
            if (typeof this.beforeClose === 'function') {
              this.close = this.getSafeClose()
              this.beforeClose(action, this, this.close)
            } else {
              this.doClose()
            }
          })
        } else {
          if (typeof this.beforeClose === 'function') {
            this.close = this.getSafeClose()
            this.beforeClose(action, this, this.close)
          } else {
            this.doClose()
          }
        }
      } else {
        if (typeof this.beforeClose === 'function') {
          this.close = this.getSafeClose()
          this.beforeClose(action, this, this.close)
        } else {
          this.doClose()
        }
      }
    },
    getFirstFocus () {
      const btn = this.$el.querySelector('.el-message-box__btns .el-button')
      const title = this.$el.querySelector('.el-message-box__btns .el-message-box__title')
      return btn || title
    },
    getInputElement () {
      const inputRefs = this.$refs.input.$refs
      return inputRefs.input || inputRefs.textarea
    },
    closeMessageBox () {
      this.$refs.component.compareExpress()
    },
    closeFourmal (type) {
      if (type === 1) {
        this.handleAction('confirm')
      }
      if (type === 2) {
        this.handleAction(this.distinguishCancelAndClose ? 'close' : 'cancel')
      }
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.uid++
        this.focusAfterClosed = document.activeElement
        // 每次打开之前都需要将 left 和 top 重置为居中
        let dom = this.$refs.elMessageBoxContainer
        if (dom) {
          dom.style.left = 'calc(50% - 466px)'
          dom.style.top = 'calc(50% - 265px)'
        }
        popup = new Dialog(this.$el, this.focusAfterClosed, this.getFirstFocus())
      }
    }
  },

  mounted () {
    this.$nextTick(() => {
      if (this.closeOnHashChange) {
        window.addEventListener('hashchange', this.close)
      }
    })
    this.dragDom = move({
      drag: this.$refs.elMessageHeader,
      dom: this.$refs.elMessageBoxContainer
    })
  },
  beforeDestroy () {
    this.dragDom && this.dragDom.removeEventListener('mousedown', () => {})
    if (this.closeOnHashChange) {
      window.removeEventListener('hashchange', this.close)
    }
    setTimeout(() => {
      popup.closeDialog()
    })
  },
  data () {
    return {
      uid: 1,
      title: undefined,
      type: '',
      width: '',
      iconClass: '',
      action: '',
      confirmButtonText: '保存',
      cancelButtonText: '',
      confirmButtonLoading: false,
      cancelButtonLoading: false,
      confirmButtonDisabled: false,
      callback: null,
      focusAfterClosed: null,
      distinguishCancelAndClose: false,
      component: '',
      componentOption: '',
      background: '#edeeee',
      parameter: {},
      value: '',
      dragDom: null
    }
  }
}
</script>

<style lang="scss">
  .popup {
    .el-message-box {
      width: 932px !important;
      height: 530px;
      .el-message-box__content {
        padding: 0;
      }
      .el-message-box__btns {
          position: relative;
          bottom: 64px;
          left: 50%;
          width: 260px;
        .el-button--small, .el-button--small.is-round {
           padding: 5px 26px;
        }
      }
    }
    .el-message-box__title {
      text-align: center;
    }
  }
  .draggable-popup {
    .el-message-box {
      position: absolute;
      top: calc(50% - 265px);
      left: calc(50% - 466px);
      overflow: visible;
      .el-message-box__header {
        user-select: none;
      }
    }
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/globalComponent/popup/popup.vue